/* eslint-disable react/prop-types */
/* eslint-env browser */
import React from 'react'

import { getCDNUrl } from '../../../../../../shared/services/media-helper'
import { useTranslator } from '../TranslatorProvider'

interface SpeciesFullListProps {
  host: string
  hostPath: string
  locale: string
  description?: string
  species: {
    id: string
    name: string
    seoName: string
    medias: { url: string; url_300?: string; url_600?: string }[]
    sciGenus?: string
    sciSpecies?: string
    sciAdditional?: string
  }[]
}

export const SpeciesFullList: React.FC<SpeciesFullListProps> = ({ species, description, locale }) => {
  const t = useTranslator(locale)

  return (
    <div>
      <div className="columns is-multiline has-padding-horizontal-medium">
        {description && (
          <div className="column is-12">
            <p>{description}</p>
            {/*
            <p>
              <a href="/map">{`${t('hydro.country.searchInput.mapLink')} >`}</a>
            </p>
            */}
          </div>
        )}
        <div className="column is-12">
          <ul>
            {species.map(oneSpecies => {
              return (
                <div key={oneSpecies.id} className="media">
                  {oneSpecies.medias && oneSpecies.medias.length > 0 && (
                    <figure className="media-left">
                      <a href={`/fish/${oneSpecies.seoName}`}>
                        <div className="image" style={{ maxWidth: 128, maxHeight: 64 }}>
                          <img
                            src={getCDNUrl(oneSpecies.medias[0], 'small', {
                              name: oneSpecies.seoName,
                              type: 'fishSpecies',
                            })}
                            className="has-object-fit-contain"
                            alt={oneSpecies.name}
                            style={{ maxWidth: 128, maxHeight: 64 }}
                          />
                        </div>
                      </a>
                    </figure>
                  )}
                  <div className="media-content is-self-centered">
                    <a href={`/fish/${oneSpecies.seoName}`} className="has-text-weight-bold has-text-break-word">
                      {oneSpecies.name}
                    </a>
                    <div className="is-size-8 has-text-grey has-text-break-word">
                      {[oneSpecies.sciGenus, oneSpecies.sciSpecies, oneSpecies.sciAdditional]
                        .filter(elt => !!elt && elt.length > 0)
                        .join(' ')}
                    </div>
                  </div>
                </div>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}
